import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  PLATFORM_ID,
  ViewEncapsulation,
} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  resetResponseAggregateProduitsAction,
  resetResponseProduitsAction,
  resetSelectProduitAction,
  searchContenudestinationAction,
  searchProduitsAction,
} from '../stores/actions/produits.actions';
import { offSpinner, onSpinner } from '../stores/actions/site.actions';
import {
  aggregateProduitDestination,
  classement,
  produit,
  responseContenudestination,
  searchProduits,
} from '../stores/interfaces/produits.interface';
import { RESPONSE_CONTENUDESTINATION_INIT_STATE } from '../stores/reducers/produits.reducer';
import {
  selectAgregateProduits,
  selectContenudestination,
  selectProduits,
} from '../stores/selectors/produits.selectors';
import { linkToObject } from '../stores/utils';
import { METADATA } from './meta';
import { Subscription } from 'rxjs';
import { selectCategorie } from '../stores/selectors/categories.selectors';

@Component({
  selector: 'produits',
  templateUrl: './produits.component.html',
  styleUrls: ['./produits.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProduitsComponent {
  myProduits: { produits: produit[] } = { produits: [] };
  produits: produit[] = [];
  classements: classement[] = [];
  responseContenudestination: responseContenudestination =
    RESPONSE_CONTENUDESTINATION_INIT_STATE;
  page: string = '';
  skip: number = 0;
  take: number = 20;
  objSearch: searchProduits = {};
  homepage: boolean = true;
  destinationpage: boolean = false;
  otherpage: boolean = false;
  destination: string = '';
  categorie: string = '';
  tag: string = '';
  search: string = '';
  scrollsearch: boolean = true;
  titre: string = '';
  metadata: any = METADATA;
  private subscriptions: Subscription[] = [];

  constructor(
    private store: Store,
    private router: Router,
    private meta: Meta,
    private title: Title,
    @Inject(PLATFORM_ID) private _platformId: Object
  ) {
    this.objSearch = linkToObject(this.router.url);
    if (Object.keys(this.objSearch).length > 0) {
      this.destination = this.objSearch.destination ?? this.destination;
      this.categorie = this.objSearch.categorie ?? this.categorie;
      this.tag = this.objSearch.tag ?? this.tag;
      this.search = this.objSearch.search ?? this.search;
    }
    this.homepage =
      this.destination === '' &&
      this.categorie === '' &&
      this.tag === '' &&
      this.search === '';

    this.destinationpage =
      this.destination !== '' &&
      this.categorie === '' &&
      this.tag === '' &&
      this.search === '';

    this.otherpage = !(this.homepage || this.destinationpage);

    this.appendItems();

    //Pour la page Destination
    if (this.destination && !(this.categorie || this.tag)) {
      this.store.dispatch(
        searchContenudestinationAction({
          destination: this.destination,
          titre: '',
          contenu: '',
        })
      );
      this.store.select(selectContenudestination).subscribe((contenu) => {
        this.responseContenudestination = { contenudestination: contenu };
      });
    }
    if (this.homepage || this.destinationpage) {
      const aggregate = this.store
        .select(selectAgregateProduits)
        .subscribe((p: aggregateProduitDestination) => {
          this.classements = p.classement;
          this.store.dispatch(offSpinner());
        });
      this.subscriptions.push(aggregate);
    }

    //Pour la page Tag et Categorie
    if (this.otherpage) {
      const selectProduit = this.store
        .select(selectProduits)
        .subscribe((p: produit[]) => {
          this.scrollsearch = (p.length > 0 && this.skip > 0)
          this.produits = [...this.produits, ...p];
          this.myProduits = { produits: this.produits };
          this.store.dispatch(offSpinner());
        });
      this.subscriptions.push(selectProduit);
    }
    if (isPlatformBrowser(this._platformId)) {
      sessionStorage.setItem('currentUrl', this.router.url);
    }
    this.formatMetadata();
  }

  changescroll(e: any) {
    this.scrollsearch = e.index === 0 ? true : false;
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.store.dispatch(resetResponseProduitsAction());
    this.store.dispatch(resetResponseAggregateProduitsAction());
    this.store.dispatch(resetSelectProduitAction());
  }
  formatMetadata() {
    let title = '';
    let desc = '';
    const regex = /X{2}/g;
    if (this.categorie) {
      const m = this.metadata[this.categorie];
      if (m) {
        title = m.title.replace(regex, this.destination);
        title += ` - ${this.tag}`;
        this.titre = m.h1.replace(regex, this.destination);
        this.titre += this.tag ? ` - ${this.tag}` : '';
        desc = m.meta.replace(regex, this.destination);
        desc += ` - ${this.tag}`;
      } else {
        desc = this.metadata['other'].meta.replace(regex, this.destination);
        desc += ` ${this.categorie} ${this.tag}`;
        title = `${this.destination} ${this.categorie} ${this.tag} `;
        this.titre = `${this.destination} ${this.categorie} ${this.tag} `;
        this.store.select(selectCategorie).subscribe((categ) => {
          this.titre = `${this.destination} ${categ.name} ${this.tag} `;
        });
      }
    } else {
      title = `${this.destination} ${this.tag} ${this.metadata['other'].title}`;
      this.titre = `${this.destination} ${this.tag} `;
      desc = this.metadata['other'].meta.replace(regex, this.destination);
      desc += ` ${this.categorie} ${this.tag}`;
    }
    this.meta.updateTag({
      name: 'description',
      content: desc,
    });
    this.titre = this.titre.trim();
    this.title.setTitle(title);
  }

  appendItems() {
    if (this.scrollsearch) {
      this.store.dispatch(onSpinner());
      this.store.dispatch(
        searchProduitsAction({
          page: this.page,
          destination: this.destination ?? '',
          categorie: this.categorie ?? '',
          tag: this.tag ?? '',
          search: this.search ?? '',
          take: this.take,
          skip: this.skip++,
        })
      );
    }
  }
}
